import type { AxiosResponse } from "axios";

import config from "@/common/config";
import type { ApiResponse } from "@/types/api.type";
import type { Institution } from "@/types/institution.type";

import ApiService from "./api.service";

export default {
  VERSION: config.api.versions.v2,

  list(): Promise<AxiosResponse<ApiResponse<Institution[]>>> {
    return ApiService.get("institutions", this.VERSION);
  },

  update(institutionId: string): Promise<AxiosResponse<ApiResponse<void>>> {
    return ApiService.put(`/institutions/${institutionId}`, {}, this.VERSION);
  }
};
